export default __webpack_public_path__ + "static/media/fnnetwork.89c61433.mp4";